module.exports = __webpack_public_path__ + "static/media/teacher.f5b098d0.png";